<script setup>
    import {computed, ref} from "vue";

    const props = defineProps({
        item: {
            type: Object,
            required: true
        }
    });
    const emit = defineEmits(['itemUpdated', 'cancel'])
    const itemLabel = ref(props.item.label)
    const itemVisibility = ref(props.item.visibility)

    const visibilityOptions = [
        {
            label: _mft('navigation:setting.visibility.loggedOut'),
            value: 'logged_out'
        },
        {
            label: _mft('navigation:setting.visibility.loggedIn'),
            value: 'logged_in'
        }
    ]

    const cancel = () => {
        emit('cancel')
    }

    const save = () => {
        props.item.label = itemLabel.value
        props.item.visibility = itemVisibility.value
        emit('itemUpdated')
    }

</script>

<template>
    <div>
        <input-label
            :label="_mft('navigation:setting.title')"
        />
        <div class="text-xs text-gray-500">{{ _mft('navigation:setting.title.description') }}</div>
        <input-text
            v-model:content="itemLabel"
        />
        <div class="flex justify-between">
            <div class="flex space-x-4">
                <a
                    v-if="item.item_page_id"
                    :href="route('pages.pagebuilder', {pageType: item.type, id: item.item_page_id})"
                    target="_blank"
                    class="mf-link"
                >{{ _mft('shared:action.edit') }}</a>
                <a
                    v-if="item.href"
                    :href="item.href"
                    target="_blank"
                    class="mf-link"
                >{{ _mft('navigation:setting.openInNewTab') }}</a>
            </div>
            <div class="flex space-x-2">
                <button-secondary
                    @click="cancel"
                >{{ _mft('shared:cancel') }}</button-secondary>
                <button-success
                    @click="save"
                >{{ _mft('shared:action.save') }}</button-success>
            </div>
        </div>
    </div>
</template>
